var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-group form-group--select", class: _vm.getClass() },
    [
      _c("link", {
        attrs: {
          rel: "stylesheet",
          href: "https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css",
        },
      }),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { class: `col-sm-${_vm.component.size}` },
          [
            _c("label", [
              _vm._v(_vm._s(_vm.component.label) + "\n        "),
              _vm.isRequired()
                ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                : _vm._e(),
            ]),
            _c(
              "v-select",
              {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: _vm.setRules(),
                    expression: "setRules()",
                  },
                ],
                ref: "selectapi",
                staticClass: "style-chooser",
                attrs: {
                  id: _vm.component.key,
                  placeholder: "Selecione uma opção",
                  multiple: _vm.component.isMultiselect === true,
                  name: _vm.component.key,
                  filterable: !_vm.component.autocomplete,
                  disabled: _vm.disabledHandler(),
                  "data-vv-name": _vm.component.key,
                  options: _vm.resultData,
                  getOptionLabel: (option) =>
                    option && Array.isArray(option.label)
                      ? option.label[0]
                      : option && option.label
                      ? option.label
                      : option,
                },
                on: {
                  search: _vm.fetchOptions,
                  "search:focus": _vm.fetchOptions,
                  open: function ($event) {
                    return _vm.visibilityChanged(true)
                  },
                  close: function ($event) {
                    return _vm.visibilityChanged(false)
                  },
                  focus: function ($event) {
                    return _vm.focusHandler()
                  },
                  "search:blur": function ($event) {
                    return _vm.blurHandler()
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "option",
                      fn: function (option) {
                        return _vm.component.data.multline
                          ? _vm._l(option.label, function (label, index) {
                              return _c("span", { key: index }, [
                                index === 0
                                  ? _c("strong", [_vm._v(_vm._s(label))])
                                  : _vm._e(),
                                index !== 0 ? _c("br") : _vm._e(),
                                index !== 0
                                  ? _c("small", [_vm._v(_vm._s(label))])
                                  : _vm._e(),
                              ])
                            })
                          : undefined
                      },
                    },
                    {
                      key: "spinner",
                      fn: function ({ loading }) {
                        return [
                          loading
                            ? _c(
                                "div",
                                {
                                  staticClass: "el-loading-spinner",
                                  staticStyle: {
                                    "border-left-color":
                                      "rgba(88,151,251,0.71)",
                                  },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "circular",
                                      attrs: { viewBox: "25 25 50 50" },
                                    },
                                    [
                                      _c("circle", {
                                        staticClass: "path",
                                        attrs: {
                                          cx: "50",
                                          cy: "50",
                                          r: "20",
                                          fill: "none",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
                model: {
                  value: _vm.component.data.currentValue,
                  callback: function ($$v) {
                    _vm.$set(_vm.component.data, "currentValue", $$v)
                  },
                  expression: "component.data.currentValue",
                },
              },
              [
                _c("template", { slot: "no-options" }, [
                  !_vm.error
                    ? _c("span", [_vm._v("Nenhum registro encontrado.")])
                    : _vm.errorMensagem
                    ? _c("span", [_vm._v(_vm._s(_vm.errorMensagem))])
                    : _c("span", [
                        _vm._v("Falha ao buscar opções"),
                        _c(
                          "button",
                          {
                            staticClass: "btn-link",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.buscar()
                              },
                            },
                          },
                          [_vm._v("clique aqui")]
                        ),
                        _vm._v("para tentar novamente."),
                      ]),
                ]),
              ],
              2
            ),
          ],
          1
        ),
        _vm.errors.has(_vm.component.key)
          ? _c("span", { staticClass: "help-block help-block--bottom" }, [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 14 14",
                    width: "14",
                  },
                },
                [
                  _c("g", { attrs: { transform: "translate(-252 -635)" } }, [
                    _c("rect", {
                      staticClass: "cls-1",
                      attrs: {
                        width: "14",
                        height: "14",
                        transform: "translate(252 635)",
                      },
                    }),
                    _c("path", {
                      staticClass: "cls-2",
                      attrs: {
                        d: "M7.4,9.8H8.6V11H7.4ZM7.4,5H8.6V8.6H7.4Zm.594-3A6,6,0,1,0,14,8,6,6,0,0,0,7.994,2ZM8,12.8A4.8,4.8,0,1,1,12.8,8,4.8,4.8,0,0,1,8,12.8Z",
                        transform: "translate(251 634)",
                      },
                    }),
                  ]),
                ]
              ),
              _vm._v(
                "\n        " + _vm._s(_vm.errors.first(_vm.component.key))
              ),
            ])
          : _vm._e(),
        !_vm.errors.has(_vm.component.key) && _vm.component.description
          ? _c("span", { staticClass: "help-block help-block--bottom" }, [
              _vm._v(_vm._s(_vm.component.description)),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }